import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import StockOutListController from '../stockoutlist/StockOutListController'
import StockOutItemFooterStyle from './css/StockOutItemFooterStyle'
import StockOutController from '../stockout/StockOutController'
import { appContext } from '../../../App'
import { stockOutItemControllerContext } from './StockOutItemController'
import { longDateAndTimeString } from '../../utilities/utilities'

function StockOutItemFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const stockOutItemController = useContext(stockOutItemControllerContext)
  const { stockOutItem, saveStockOut, deleteStockOut,
    restoreStockOut, deleteStockInAutoPosted, getStockOutByID } = stockOutItemController
  const [successMessage, setSuccessMessage] = useState(false)

  const onClickEdit = async (e) => {
    let so = await getStockOutByID(app, stockOutItem._id)

    const showMessageBox = () => {
      let message_box_content = null
      const last_modified_by = so.log.last_modified_by.name
      const last_modified = longDateAndTimeString(new Date(so.date_time_modified))

      const onClick = async (button) => {
        if (button === 'Yes') {
          // Fetch updated [so] again just incase the user delayed the response on messagebox
          // This makes sure we are responding to a data that still exist
          so = await getStockOutByID(app, stockOutItem._id)

          if (so) {
            // Will restore products item inventory here only if the item status is Posted
            // The logic is set on the API backend. It will not restore On Process stockin.
            if (so.status === 'Posted') await restoreStockOut(app, so._id)

            await deleteStockInAutoPosted(app, so._id)
            so.status = 'On Process'
            setContent(<StockOutController stockOutItem={so}/>)

            ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
          } else { // SO no longer exist
            ReactDOM.render (
              <ModalWindow
                id='mw-child'
                header='SO Not Found'
                footer={null}>
                <div className='messagebox'>
                  <div className='messagebox-content'>
                    <div>The StockOut file/record no longer exist.</div>
                  </div>
                  <div className='button-container'>
                    <button
                      onClick={() => {
                        setContent(<StockOutListController />)
                        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
                      }}
                      className='pospro-action-btn top-anchor'>
                      Ok
                    </button>
                  </div>
                </div>
              </ModalWindow>,
              document.getElementById('mw-parent')
            )
          }
        } else ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      // Determine stockin status first to set proper messagebox content
      switch(so.status) {
        case 'On Process':
          message_box_content =
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>This item is marked as On Process.</div>
                <div>It was last modified by <i>{last_modified_by}</i> on <i>{last_modified}</i></div>
                <div>Proceed only if you are certain it is no longer on process.</div>
                <br />
                <div>Are you sure you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
        break
        default: // Posted
          message_box_content =
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Editing posted stockin will restore back all the item listed in here.&nbsp;
                Negative result will round-off/reset to 0 inventory on the particular item.</div>
                <br/>
                <div>Are you sure you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No')}} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes')}} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
      }

      ReactDOM.render(
        <ModalWindow id='mw-parent' height='30' width='40' header='Edit Stockout' footer={null}>
          {message_box_content}
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showMessageBoxSONotFound = () => {
      const onClick = async () => {
        setContent(<StockOutListController />)
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      ReactDOM.render (
        <ModalWindow id='mw-parent' height='20' width='25' header='SO Not Found' footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>The StockOut file/record no longer exist.</div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }
    
    // Check if stockout still exist/available
    if (so) {
      if (so.status === 'Unposted') {
        await deleteStockInAutoPosted(app, so._id)
        so.status = 'On Process'
        setContent(<StockOutController stockOutItem={so}/>)
      } else { showMessageBox() }
    } else { showMessageBoxSONotFound() }
  }

  const onClickDelete = (e) => {
    const onClick = async (button) => {
      if (button === 'Yes') {
        deleteStockOut(app, stockOutItem._id)
        .then(success => {
          if (success) {
            // call Delete on stockIn here only successful in Delete stockOut
            deleteStockInAutoPosted(app, stockOutItem._id)
            .then(result => {
              if (result) {
                setSuccessMessage('Deleted successfully! Loading StockOut List, please wait...')
                setTimeout(() => {
                  setSuccessMessage('')
                  setContent(<StockOutListController />)
                }, 1000)
              } else { // Something went wrong
                setSuccessMessage('Deleting StockIn AutoPosted failed! Loading StockOut List, please wait...')
                setTimeout(() => {
                  setSuccessMessage('')
                  setContent(<StockOutListController />)
                }, 1000)
              }
            })
          } else { /* SO no longer exist */
            setSuccessMessage('Stockout file/record no longer exist! Loading StockOut List, please wait...')
            setTimeout(() => {
              setSuccessMessage('')
              setContent(<StockOutListController />)
            }, 1000)
          }
        })
      }
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width='35'
        height='35'
        header="Delete Stock-Out Record"
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            {
              // With Stock-In
              (stockOutItem.dest_warehouse.id && stockOutItem.status === 'Posted')
              ? <div>You are about to delete this stock-out file. All items will also be restored/putback to the inventory and the associated Stock-In record will be deleted.</div>
              : null
            }
            {
              // Without Stock-In
              (!stockOutItem.dest_warehouse.id && stockOutItem.status === 'Posted')
              ? <div>You are about to delete this stock-out file. All items with OK status will also be restored/putback to inventory.</div>
              : null
            }
            {
              // Unposted only
              (stockOutItem.status === 'Unposted' || stockOutItem.status === 'Inactive')
              ? <div>You are about to delete this stock-out file. It will not affect the inventory.</div>
              : null
            }
            <br/>
            <p>Are you sure you want to continue?</p>
          </div>
          <div className='button-container'>
            <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
            <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickPost = (e) => {
    const onClick = async (button) => {
      if (button === 'Yes') {
        stockOutItem.status = 'Posted'
        saveStockOut(app, stockOutItem)
        .then(so => {
          if (so) setSuccessMessage('Posted successfully! Loading StockOut List, please wait...')
          else setSuccessMessage('Something went wrong. Post failed! Loading StockOut List, please wait...')
          setTimeout(() => {
            setSuccessMessage('')
            setContent(<StockOutListController />)
          }, 1000)
        })
      }
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        header="Post"
        footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>You are about to remove these stocks inventory.</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  let userHaveFC = true
  if (app.client.signed_in !== 'admin') userHaveFC = app.client.signed_in.user_access.stockout_fc

  return (
    <ContentFooter>
      <div id="stock-out-item-footer-container">
        <span style={{visibility: successMessage ? 'visible' : 'hidden'}} className='notification'>{successMessage}</span>
        <div className='translist-button-container'>
          <button className="pospro-action-btn"
            id="stockout-translist-button"
            type="button"
            onClick={() => setContent(<StockOutListController />)}>
            <FontAwesomeIcon icon='undo-alt'/>&nbsp;Back to Stockout's List
          </button>
          <button className="pospro-action-btn"
            id="stockout-item-edit-button"
            type="button"
            onClick={onClickEdit}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Edit
          </button>
          <button className="pospro-action-btn"
            style={{display: (stockOutItem.status === 'On Process') ? 'none' : 'block'}}
            id="stockout-item-delete-button"
            type="button"
            onClick={onClickDelete}>
            <FontAwesomeIcon icon='times'/>&nbsp;Delete
          </button>
          <button className="pospro-action-btn"
            id="stockout-item-print-button"
            type="button"
            onClick={() => window.print()}>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
          <button className="pospro-action-btn"
            style={{display: ((stockOutItem.status === 'Unposted') && userHaveFC) ? 'block' : 'none'}}
            id="stockout-item-post-button"
            type="button"
            onClick={onClickPost}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Post
          </button>
          <button className="pospro-action-btn"
            id="stockout-addnew-button"
            type="button"
            onClick={() => setContent(<StockOutController />)}>
            <FontAwesomeIcon icon='plus'/>&nbsp;Add New
          </button>
        </div>
      </div>
      <StockOutItemFooterStyle signed_in={app.client.signed_in} />
    </ContentFooter>
  );
}

export default React.memo(StockOutItemFooter)
